/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGoogle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 1c2.965 0 5.455 1.09 7.36 2.865L16.205 7.02c-1.14-1.09-2.59-1.645-4.205-1.645-2.865 0-5.29 1.935-6.155 4.535l-.001-.002a6.73 6.73 0 0 0-.336 1.783L5.5 12c0 .725.125 1.43.345 2.09.865 2.6 3.29 4.535 6.155 4.535 1.48 0 2.74-.39 3.725-1.05l-.001.001a5.06 5.06 0 0 0 2.142-3.066l.054-.255H12V10h10.36c.13.72.2 1.47.2 2.25 0 3.35-1.2 6.17-3.28 8.085C17.46 22.015 14.97 23 12 23c-4.3 0-8.02-2.465-9.83-6.06v-.001a10.986 10.986 0 0 1-1.163-4.531L1 12c0-1.775.425-3.455 1.17-4.94h.001a10.994 10.994 0 0 1 9.508-6.055z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGoogle as Google };
